// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3hqYe","head":"ProcedureTableInfo_head__2uLwE"};